import React, { useState } from 'react';
import { categoriesAPI } from '../../services/api';
import { ModernInput, ModernButton } from '../ui/ModernComponents';
import { Save, X, Package } from 'lucide-react';
import toast from 'react-hot-toast';

const defaultForm = {
  name: '',
};

function AddCategoryForm({ onSuccess, onCancel }) {
  const [form, setForm] = useState(defaultForm);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await categoriesAPI.createCategory(form);
      toast.success('Catégorie ajoutée');
      setForm(defaultForm);
      if (onSuccess) onSuccess(res.data);
    } catch (err) {
      toast.error('Erreur lors de la sauvegarde');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div>
          <label className="block text-base font-semibold text-gray-800 mb-1">Nom de la catégorie</label>
          <ModernInput
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Ex: Montures, Verres, Accessoires"
            icon={<Package className="w-5 h-5" />}
            required
            className="w-full"
          />
        </div>
      </div>
      <div className="flex justify-end space-x-2 pt-2">
        <ModernButton type="button" variant="secondary" onClick={onCancel} icon={<X className="w-4 h-4" />}>
          Annuler
        </ModernButton>
        <ModernButton type="button" variant="primary" icon={<Save className="w-4 h-4" />} disabled={loading} onClick={handleSubmit}>
          {loading ? 'Ajout...' : 'Ajouter'}
        </ModernButton>
      </div>
    </div>
  );
}

export default AddCategoryForm; 